export const tr = {
    'many-linked-camps-count': '{count} kampanya',
    'one-linked-camps': '{count} kampanya',
    'some-linked-camps': '{count} kampanya',
    'zero-linked-camps': 'bağlı kampanya yok'
};
